import { ChevronLeft, ChevronRight } from 'lucide-react'
import { Button } from '../primitives/Button'

const DAY_NAMES = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT']
const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

interface MobileDayHeaderProps {
  dateStr: string
  onPrev(): void
  onNext(): void
  onJumpToToday(): void
  isToday: boolean
}

export function MobileDayHeader({ dateStr, onPrev, onNext, onJumpToToday, isToday }: MobileDayHeaderProps) {
  // Parse YYYY-MM-DD in local time to avoid UTC offset shifting the day.
  const [year, month, day] = dateStr.split('-').map(Number)
  const date = new Date(year, month - 1, day)
  const dayName = DAY_NAMES[date.getDay()]
  const dayNum = date.getDate()
  const monthName = MONTH_NAMES[date.getMonth()]

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '12px 16px 8px',
        borderBottom: '1px solid var(--color-border)',
        gap: '8px',
      }}
    >
      <button
        onClick={onPrev}
        aria-label="Previous day"
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: 'var(--color-ink-muted)',
          padding: '6px',
          display: 'flex',
          alignItems: 'center',
          flexShrink: 0,
        }}
      >
        <ChevronLeft size={20} strokeWidth={1.5} />
      </button>

      <div style={{ flex: 1, textAlign: 'center' }}>
        <div
          className="eyebrow"
          style={{ color: isToday ? 'var(--color-accent)' : 'var(--color-ink-faint)' }}
        >
          {dayName}
        </div>
        <div
          style={{
            fontFamily: 'var(--font-serif)',
            fontSize: 'var(--text-day-num)',
            fontWeight: 500,
            lineHeight: 1.05,
            color: isToday ? 'var(--color-ink)' : 'var(--color-ink-muted)',
            letterSpacing: '-0.02em',
          }}
        >
          {dayNum}
        </div>
        <div
          style={{
            fontFamily: 'var(--font-serif)',
            fontStyle: 'italic',
            fontSize: '0.875rem',
            color: 'var(--color-ink-faint)',
          }}
        >
          {monthName}
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', flexShrink: 0 }}>
        {!isToday && (
          <Button variant="bracketed" onClick={onJumpToToday} style={{ fontSize: '0.625rem' }}>
            today
          </Button>
        )}
        <button
          onClick={onNext}
          aria-label="Next day"
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: 'var(--color-ink-muted)',
            padding: '6px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <ChevronRight size={20} strokeWidth={1.5} />
        </button>
      </div>
    </div>
  )
}
